export const highlightIcons = {
  '1': '⭐',
  '2': '❤️',
  '3': '💲',
} as const;

export const highlightTooltips = {
  '1': 'New Customer',
  '2': 'TLC Required',
  '3': 'Big Spender',
};
